import { render, staticRenderFns } from "./PromoPeriodSelector.vue?vue&type=template&id=0b425e30&scoped=true"
import script from "./PromoPeriodSelector.vue?vue&type=script&lang=js"
export * from "./PromoPeriodSelector.vue?vue&type=script&lang=js"
import style0 from "./PromoPeriodSelector.vue?vue&type=style&index=0&id=0b425e30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b425e30",
  null
  
)

export default component.exports